<template>
  <div>
    <panel>
      <div slot="title">Your recent reports</div>
      <div slot="body">
        <div class="row">
          <div class="col-xs-12">
            <div v-if="reports.length !== 0">
              <div v-for="report of reports" class="row report-listing" :key="report.id">
                <div class="col-xs-7 col-sm-7 col-md-8">
                  {{ report.company_name || report.name }}<br />{{ report.registration_number }}
                </div>
                <div class="col-xs-5 col-sm-5 col-md-4">
                  <router-link
                    v-if="report.status === 'processed'"
                    :to="{ path: '/reports/' + report.report_id }"
                  >
                    <a role="button" class="btn btn-viewReport btn-recentReports btn-xs pull-right">
                      View report >
                    </a>
                  </router-link>
                  <a
                    class="btn btn-viewReport btn-recentReports btn-xs pull-right"
                    disabled
                    role="button"
                    v-else-if="report.status === 'processing' && report.percent_complete === 0"
                  >
                    Pending
                  </a>
                  <a
                    class="btn btn-viewReport btn-recentReports btn-xs pull-right"
                    disabled
                    role="button"
                    v-else-if="report.status === 'processing' && report.percent_complete > 0"
                  >
                    Processing
                  </a>
                </div>
              </div>
            </div>
            <div v-else class="text-center">No recent reports</div>

            <div class="row">
              <div class="col-xs-12 view-all-footer text-center">
                <router-link to="/reports/">
                  <a role="button" class="btn btn-view-all-reports btn-xs">View all reports ></a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </panel>
  </div>
</template>

<script>
import Panel from '@/components/app/Panel';
import Axios from '@/packages/axios/Axios';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['current_user']),
  },
  components: {
    Panel,
  },
  data() {
    return {
      reports: [],
    };
  },
  methods: {
    refresh() {
      Axios.get('/v1/reports/recent')
        .then((response) => {
          this.reports = response.data;
        })
        .catch((e) => {
          // console.log('recent reports');
          if (e.response) {
            switch (e.response.status) {
              case 401:
                this.$router.push('/error/401');
                break;
              case 403:
                // this.$router.push('/error/403');
                break;
              case 404:
                // this.$router.push('/error/404');
                break;
              default:
                this.$router.push('/error/unknown');
            }
          }
        });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>

</style>
